import GetUserLang from '../Utils/GetUserLang';
import { setAppLang } from '../Slice';
import { PropsWithChildren, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function LangProvider(props: PropsWithChildren<unknown>) {
    const { i18n, i18n: { language } } = useTranslation();
    const [ready, setReady] = useState(false);
    const l = useMemo(() => GetUserLang(), []);

    useEffect(() => {
        try {
            document.documentElement.lang = language;
        } catch (error) {
            console.error('Error setting language:', error);
        }
    }, [language]);

    useEffect(() => {
        document.documentElement.lang = l;
        setAppLang(l);
        if (i18n.language === l) {
            setReady(true);
            return;
        }
        i18n.changeLanguage(l)
            .catch((error) => {
                console.error('Error changing language:', error);
            }).finally(() => {
                setReady(true);
            });
    }, [i18n, l]);

    if (!ready) return <div>Loading...</div>;
    return <>{props.children}</>;
}
import GetUserLang from '../Utils/GetUserLang';
import { setAppLang } from '../Slice';
import { PropsWithChildren, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function LangProvider(props: PropsWithChildren<unknown>) {
    const { i18n, i18n: { language } } = useTranslation();
    const [ready, setReady] = useState(false);
    const l = useMemo(() => GetUserLang(), []);

    useEffect(() => {
        try {
            document.documentElement.lang = language;
        } catch (error) {
            console.error('Error setting language:', error);
        }
    }, [language]);

    useEffect(() => {
        document.documentElement.lang = l;
        setAppLang(l);
        if (i18n.language === l) {
            setReady(true);
            return;
        }
        i18n.changeLanguage(l)
            .catch((error) => {
                console.error('Error changing language:', error);
            }).finally(() => {
                setReady(true);
            });
    }, [i18n, l]);

    if (!ready) return <div>Loading...</div>;
    return <>{props.children}</>;
}
